import { createFileRoute } from '@tanstack/react-router';
import { DocumentLayoutRegistryPage } from '../-shared/-components/DocumentLayoutRegistryPage';
export const Route = createFileRoute('/_staff/attendances/_layout/settings/in-house-reports/')({
  component: () => <DocumentLayoutRegistryPage kind="inHouseReport" />
});